<div class="particles-container flex items-center justify-center">
  <ngx-particles
    id="home-user-banner-particles"
    [options]="particlesOptions"
  ></ngx-particles>
</div>
<svg-icon class="bg" src="assets/images/ui-effects/background-vector.svg" />
<div class="user black-third-wrapper rounded-6 flex flex-col padding-16">
  @if (user()) {
  <div class="welcome">
    <p class="welcome__title">Welcome back,</p>
    <p class="welcome__subtitle">
      {{ user()?.name }}
    </p>
  </div>
  <app-user-level-bar class="level" [user]="user()!"></app-user-level-bar>
  } @else {
  <div class="welcome">
    <p class="welcome__title">Welcome to TF2Hunt!</p>
    <app-login-button class="login-button"></app-login-button>
  </div>
  }
</div>
